/* @params 
    state change function provided by zustand -> set
    changing state name -> provide by us
    the payload it can be function or changed state provided by us


    the purpose for this utility is provide access to previousState like useState hook
*/
import { StateCreator } from 'zustand'
import { updateWithAccessToPreviousState } from '../utils/updateWithAccessToPreviousState'

export interface DamageRegistrationStepSlice {
  damageRegistrationStep: number
  setDamageRegistrationStep: (payload: number) => void
}

const createDamageRegistrationStepSlice: StateCreator<
  DamageRegistrationStepSlice
> = (set) => ({
  damageRegistrationStep: 0,
  setDamageRegistrationStep: (payload) =>
    updateWithAccessToPreviousState(set, 'damageRegistrationStep', payload),
})

export default createDamageRegistrationStepSlice
